<template>
  <ion-page>
    <ion-tabs
      @ionTabsWillChange="beforeTabChange"
      @ionTabsDidChange="afterTabChange"
    >
      <div>
        <logo-header/>
      </div>
      <div class="ion-text-center ion-padding-horizontal">
        <ion-text color="primary">
          <h4 style="mt-0 mb-2">
            {{ selectedCounty ? selectedCounty.name : "No Selected County" }}
          </h4>
        </ion-text>
      </div>
      <ion-tab-bar slot="top" :selected-tab="selectedTab">
        <ion-tab-button tab="permits" href="/dashboard/permits">
          <ion-icon :icon="listOutline"></ion-icon>
          <ion-label>{{ $t("menu.permits") }}</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="weather" href="/dashboard/weather">
          <ion-icon :icon="cloudOutline"></ion-icon>
          <ion-label>{{ $t("menu.weather") }}</ion-label>
        </ion-tab-button>
        <!-- <ion-tab-button tab="counties" href="/dashboard/counties">
          <ion-icon :icon="locationOutline"></ion-icon>
          <ion-label>{{ $t("menu.counties") }}</ion-label>
        </ion-tab-button> -->
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {
  IonIcon,
  IonLabel,
  IonPage,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonText
} from "@ionic/vue";
import { listOutline, cloudOutline,  } from "ionicons/icons";
import LogoHeader from "../../components/LogoHeader.vue";


export default defineComponent({
  name: "DashboardPage",
  components: {
    IonIcon,
    IonLabel,
    IonPage,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonText,
    LogoHeader
  },
  setup() {
    const selectedTab = ref('permits')
    const beforeTabChange = () => {
      // do something before tab change
    };
    const afterTabChange = () => {
      // do something after tab change
    };
    return {
      selectedTab,
      listOutline,
      
      cloudOutline,
      beforeTabChange,
      afterTabChange,
    };
  },
  mounted() {
    this.$store.dispatch("initFromStorage");
    if (this.$route.path.includes('permits')) {
      this.selectedTab = 'permits'
    } else if (this.$route.path.includes('counties')) {
      this.selectedTab = 'counties'
    }
    setTimeout(()=> {
      if (!this.customer) {
        this.$router.push('/')
      }
    }, 200)
  },
  computed: {
    selectedCounty(): any {
      return this.$store.state.selectedCounty;
    },
    customer(): any {
      return this.$store.state.myCustomer;
    },
  },
});
</script>